import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAuthentication } from "./common/hooks/useAuthentication";
import LoadingScreen from "./common/LoadingScreen";
import { Dialog } from "@mui/material";
import LoginForm from "./pages/Admin/Login/LoginForm";
import { useAlertNotification } from "./common/hooks/useAlertNotification";
import { onLogout } from "./redux/authSlice";

const AuthProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, isSessionLost, validateSession, redirectToLoginPage } = useAuthentication();
    const { setAlert } = useAlertNotification();
    const [managerSessionChecked, setManagerSessionChecked] = useState(false);

    const onError = (error) => {
        setAlert({
            message: error.message,
            severity: 'error'
        });
    }

    // Always validate manager session with the API on mount so /admin/* never trusts Redux alone.
    // Backend POST /api/auth/validateSession requires MANAGER (401/403 otherwise).
    useEffect(() => {
        let cancelled = false;

        const checkManagerSession = async () => {
            try {
                await validateSession();
            } catch {
                dispatch(onLogout());
                redirectToLoginPage();
            } finally {
                if (!cancelled) {
                    setManagerSessionChecked(true);
                }
            }
        };

        checkManagerSession();
        return () => {
            cancelled = true;
        };
        // Intentionally run once on mount; validateSession/redirectToLoginPage are not stable references.
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!managerSessionChecked || !isAuthenticated) {
        return <LoadingScreen />;
    }

    return <>
        {isSessionLost && <LoginPopup onError={onError} />}
        {children}
    </>;
}

const LoginPopup = ({ onError }) => {
    return <Dialog open sx={{ zIndex: (theme) => theme.zIndex.authModal }}>
        <LoginForm onError={onError} />
    </Dialog>;
}

export default AuthProvider;